import React from "react";
import "./style.css";
import Slider from "react-slick";
import servicesList from "./supported";
import AOS from "aos";
import "aos/dist/aos.css";
import "animate.css";
import { withRouter, Link } from "react-router-dom";
import * as routes from "../../constants/routes";
import AuthUserContext from "../AuthUserContext";
import URL from "../../constants/url";
import checkCircle from "../images/check-circle.svg";

const axios = require("axios");
// class Land extends React.PureComponent {
const Land = ({ history }) => {
  // componentDidMount() {
  //   AOS.init({
  //     duration: 2000
  //   });
  // }
  // render() {
  return (
    <AuthUserContext.Consumer>
      {authUser =>
        authUser ? (
          <AuthLanding history={history} />
        ) : (
          <NonAuthLanding history={history} />
        )
      }
    </AuthUserContext.Consumer>
  );
  // }
};

class NonAuthLanding extends React.Component {
  render() {
    return (
      <div className="homepage">
        <div className="container">
          {/* <button onClick={()=>{
          console.log(URL);
          axios.get(URL).then(res => {
            console.log(res);
          })
        }}>tikla</button> */}
          <Navbar history={this.props.history} />
          <img src={require("../images/top-right-2.svg")} id="top-right" />
          {/* <h1>H!</h1> */}
          {/* <Welcome /> */}

          <Welcome history={this.props.history} />

          <img
            src={require("../images/after-welcome-left.svg")}
            id="afterWelcomeLeft"
          />
          <Quote />
          <HowItWorks />
          <ScreenDemo history={this.props.history} />
          <Services />
          <Pricing />
          <PaymentMethods />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
      </div>
    );
  }
}

class AuthLanding extends React.Component {
  render() {
    return (
      <div className="homepage">
        <div className="container">
          <nav className="navbar navbar-light navbar-expand-md bg-faded justify-content-center">
            <a href="/" className="navbar-brand d-flex w-50 mr-auto">
              {/* smsfor.me LOGO */}
              <img
                style={{ marginRight: "10px" }}
                src={require("../images/check.svg")}
                height="35px"
              />
              {/* {console.log(this.props)} */}
              <p>
                Smsfor
                <span style={{ color: "rgb(77, 207, 224)" }}>.me</span>
              </p>
              <span
                style={{
                  fontSize: "10px",
                  height: "100%",
                  color: "white",
                  backgroundColor: "#007bff80",
                  borderRadius: "5px",
                  padding: "1px 4px",
                  marginLeft: "5px"
                }}
              >
                BETA
              </span>
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#collapsingNavbar3"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div
              className="navbar-collapse collapse w-100"
              id="collapsingNavbar3"
            >
              <ul className="navbar-nav w-100 justify-content-center">
                <li className="nav-item active">
                  <a className="nav-link" href="#home">
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#how">
                    How It Works
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#services">
                    Services
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#pricing">
                    Pricing
                  </a>
                </li>
              </ul>
              <ul className="nav navbar-nav ml-auto w-100 justify-content-end">
                <li className="nav-item">
                  {/* <a className="nav-link" href="#">
            Sign Up
          </a> */}
                  <button
                    type="button"
                    className="btn"
                    onClick={() => {
                      this.props.history.push("/numbers");
                    }}
                  >
                    DASHBOARD
                  </button>
                </li>
              </ul>
            </div>
          </nav>
          <img
            src={require("../images/top-right-2.svg")}
            id="top-right"
          />
          {/* <h1>H!</h1> */}
          {/* <Welcome /> */}

          <Welcome history={this.props.history} />

          <img
            src={require("../images/Group-10.png")}
            id="afterWelcomeLeft"
          />
          <Quote />
          <HowItWorks />
          <ScreenDemo history={this.props.history} />
          <Services />
          <Pricing />
          <PaymentMethods />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
      </div>
    );
  }
}

class PaymentMethods extends React.Component {
  render() {
    return (
      <div className="container">
        <div
          className="d-flex justify-content-around flex-wrap paymentIcons"
          style={{ opacity: 0.7 }}
        >
          <img src={require("./img/payment/paypal.svg")} />
          <img src={require("./img/payment/mastercard.svg")} />
          <img src={require("./img/payment/visa.svg")} />
          <img
            src={require("./img/payment/btc.png")}
            className="cryptoIcon"
            data-toggle="tooltip"
            data-placement="bottom"
            title="Bitcoin"
          />
          <img
            src={require("./img/payment/eth.png")}
            className="cryptoIcon"
            data-toggle="tooltip"
            data-placement="bottom"
            title="Ethereum"
          />
          <img
            src={require("./img/payment/ltc.png")}
            className="cryptoIcon"
            data-toggle="tooltip"
            data-placement="bottom"
            title="Litecoin"
          />
          <img
            src={require("./img/payment/bch.png")}
            className="cryptoIcon"
            data-toggle="tooltip"
            data-placement="bottom"
            title="Bitcoin Cash"
          />
        </div>
      </div>
    );
  }
}

const Pricing = () => {
  return (
    <div id="pricing">
      <img src={require("./img/pricingRight.svg")} id="pricingRightShape" />
      <img src={require("./img/pricingLeft.svg")} id="pricingLeftShape" />
      <div>
        <h2 style={{ textAlign: "center" }}>Pricing</h2>
        <div className="line-shape" style={{ marginBottom: "40px" }} />
      </div>
      <div className="row d-flex justify-content-center">
        <div className="priceCard" data-aos="flip-right">
          <p className="priceCardHeader">Single Verification</p>
          <ul style={{ listStyle: "none" }}>
            <li>
              <img src={checkCircle} />
              USA & UK Numbers
            </li>
            <li>
              <img src={checkCircle} />
              1 Service
            </li>
            <li>
              <img src={checkCircle} />
              1 Verification
            </li>
            <li>
              <img src={checkCircle} />
              Fully Automated
            </li>
            <li>
              <img src={checkCircle} />
              24/7 Support
            </li>
            <li style={{ paddingBottom: "20px" }}>
              <img src={checkCircle} />
              Unique Number
            </li>
          </ul>
          <div className="ca-price d-flex justify-content-center">
            <span style={{ fontSize: "12px", marginLeft: "-30px" }}>
              from $
            </span>
            <p style={{ fontSize: "35px", lineHeight: "1" }}>0.25</p>
          </div>
        </div>

        <div className="vertical-line" data-aos="fade-up" />

        <div className="priceCard" data-aos="flip-left">
          <p className="priceCardHeader">Rent a Number</p>
          <ul style={{ listStyle: "none" }}>
            <li>
              <img src={checkCircle} />
              USA & UK Numbers
            </li>
            <li>
              <img src={checkCircle} />
              1 Month
            </li>
            <li>
              <img src={checkCircle} />
              1 Private Number
            </li>
            <li>
              <img src={checkCircle} />
              Unlimited Verification
            </li>
            <li>
              <img src={checkCircle} />
              Fully Automated
            </li>
            <li>
              <img src={checkCircle} />
              24/7 Support
            </li>
          </ul>
          <div className="ca-price d-flex justify-content-center">
            <span style={{ fontSize: "13px" }}>$</span>{" "}
            <p style={{ fontSize: "35px", lineHeight: "1" }}>4.99</p>
            <span
              style={{
                fontSize: "13px",
                paddingTop: "14px",
                paddingLeft: "4px"
              }}
            >
              {" "}
              /mo
            </span>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
    </div>
  );
};

class Navbar extends React.Component {
  render() {
    return (
      <nav className="navbar navbar-light navbar-expand-md bg-faded justify-content-center">
        <a href="/" className="navbar-brand d-flex w-50 mr-auto">
          {/* smsfor.me LOGO */}
          <img
            style={{ marginRight: "10px" }}
            src={require("../images/check.svg")}
            height="35px"
          />
          {/* {console.log(this.props)} */}
          <p>
            Smsfor
            <span style={{ color: "rgb(77, 207, 224)" }}>.me</span>
          </p>
          <span
            style={{
              fontSize: "10px",
              height: "100%",
              color: "white",
              backgroundColor: "#007bff80",
              borderRadius: "5px",
              padding: "1px 4px",
              marginLeft: "5px"
            }}
          >
            BETA
          </span>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#collapsingNavbar3"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div className="navbar-collapse collapse w-100" id="collapsingNavbar3">
          <ul className="navbar-nav w-100 justify-content-center">
            <li className="nav-item active">
              <a className="nav-link" href="#home">
                Home
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#how">
                How It Works
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#services">
                Services
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#pricing">
                Pricing
              </a>
            </li>
          </ul>
          <ul className="nav navbar-nav ml-auto w-100 justify-content-end">
            <li className="nav-item">
              <a
                className="nav-link"
                style={{ color: "white", cursor: "pointer" }}
                onClick={() => {
                  this.props.history.push("./signin");
                }}
              >
                Login
              </a>
            </li>
            <li className="nav-item">
              {/* <a className="nav-link" href="#">
            Sign Up
          </a> */}
              <button
                type="button"
                className="btn"
                onClick={() => {
                  this.props.history.push("/signup");
                }}
              >
                GET STARTED
              </button>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

class Welcome extends React.Component {
  render() {
    return (
      <div className="container" id="welcome">
        {/* <div className="container" style={{ border: "1px solid black" }}> */}
        <div className="row d-flex flex-wrap" style={{ marginTop: "120px" }}>
          <div className="col d-flex flex-column justify-content-center leftColumn">
            <div id="leftColumnDiv">
              <div className="row">
                <div>
                  <h2>Verify your accounts online.</h2>
                  <h2>
                    <span style={{ color: "#1a82e7" }}>Quick</span> and{" "}
                    <span style={{ color: "#1a82e7" }}>Easy</span>
                  </h2>
                </div>
              </div>
              <div className="row col-md-8">
                <p>
                  Start using your unique one-time phone number for
                  verification.
                </p>
              </div>
              <div className="row">
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{
                    marginTop: "20px",
                    padding: "10px 20px",
                    borderRadius: "8px"
                  }}
                  onClick={() => {
                    this.props.history.push("./signup");
                  }}
                >
                  GET STARTED
                </button>
              </div>
            </div>
          </div>

          <div className="col d-flex justify-content-center">
            <img
              src={require("../images/smsReceived.png")}
              style={{ padding: "100px 0" }}
              data-aos="fade-left"
              data-aos-delay="1000"
            />
          </div>
        </div>
      </div>
    );
  }
}

const HowItWorks = () => {
  return (
    <div style={{ marginTop: "100px" }} className="howItWorks" id="how">
      <h2 style={{ textAlign: "center" }}>Here is How it Works</h2>
      <div className="line-shape" />

      <div id="howItWorks">
        <div>
          <img src={require("./img/how/1.svg")} />
          <p>
            Get your <span style={{ color: "rgb(26, 130, 231)" }}>unique</span>{" "}
            temporary number
          </p>
        </div>
        {/* <i className="material-icons">keyboard_arrow_right</i> */}
        <img src={require("./img/how/sep.svg")} className="sep" />
        <div>
          <img src={require("./img/how/2.svg")} />
          <p>Use it on any site/app</p>
        </div>
        <img src={require("./img/how/sep.svg")} className="sep" />
        <div>
          <img src={require("./img/how/3.svg")} />
          <p>
            <span style={{ color: "rgb(26, 130, 231)" }}>Receive</span> the
            verification code
          </p>
        </div>
        <img src={require("./img/how/sep.svg")} className="sep" />
        <div>
          <img src={require("./img/how/4.svg")} />
          <p>
            <span style={{ color: "rgb(26, 130, 231)" }}>Done!</span> That's all
          </p>
        </div>
        {/* <i className="material-icons">keyboard_arrow_right</i>
        <div>
          <img src={require("./img/how/5.png")} />
          <p>Done,Thats all :)</p>
        </div> */}
      </div>
    </div>
  );
};

const Quote = () => {
  return (
    <div>
      <h1
        style={{
          textAlign: "center",
          marginTop: "100px"
          // marginBottom: "100px"
        }}
      >
        Stop Leaking Your Real Number
      </h1>
      <div className="line-shape" />
    </div>
  );
};

class ScreenDemo extends React.Component {
  render() {
    return (
      <div className="screenDemo">
        <div className="hideOnSmall">
          <h2 style={{ textAlign: "center" }}>Simple and Modern Interface</h2>
          <div className="line-shape" style={{ marginBottom: "20px" }} />
        </div>
        <div
          className="d-flex justify-content-center"
          style={{ marginBottom: "100px" }}
        >
          <div data-aos="fade-up">
            <img src={require("./img/core-img/ss.png")} id="screenShot" />
            {/* <img
            src="https://a.icons8.com/rdmVpwQW/iJf0AB/group-9normal.svg"
            id="screenShot"
          /> */}
          </div>
          <img src={require("./img/mid.png")} id="midImg" />
        </div>
        <button
          type="button"
          className="btn btn-primary"
          style={{
            marginTop: "20px",
            padding: "10px 20px",
            borderRadius: "8px",
            display: "block",
            margin: "0 auto"
          }}
          onClick={() => {
            this.props.history.push("./signup");
          }}
        >
          GET STARTED
        </button>
      </div>
    );
  }
}

const servicesArr = servicesList.map(e => {
  return (
    <div className="serviceContainer" key={e.name}>
      <img src={e.logo} />
      <p>{e.name}</p>
    </div>
  );
});

class Services extends React.Component {
  componentWillMount() {
    AOS.init({
      duration: 2000
    });
  }
  render() {
    const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      speed: 1000,
      // autoplaySpeed: 3000,
      cssEase: "linear",
      swipeToSlide: true,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    };

    return (
      <div className="services-supported" id="services">
        <img
          // src="https://a.icons8.com/rdmVpwQW/JTsDeF/rectangle-3normal.svg"
          src={require('../images/Rectangle-3.svg')}
          id="ovalBack"
        />
        <h2 style={{ textAlign: "center", paddingTop: "30px" }}>
          Supported Services
        </h2>
        <div className="line-shape" style={{ marginBottom: "20px" }} />
        <h5 style={{ textAlign: "center", marginBottom: "20px" }}>
          50+ and Counting!
        </h5>

        <Slider {...settings}>{servicesArr}</Slider>
        {/* {console.log(servicesList)} */}
      </div>
    );
  }
}

export default withRouter(Land);
